import { supabaseClient } from "../services/supabase";
import type { EmployeeProfile } from "./types";

export async function signIn(
  identifier: string,
  password: string,
) {
  const normalized = identifier
    .trim()
    .toLowerCase();

  const email = normalized.includes("@")
    ? normalized
    : `${normalized}@sunset.local`;

  const { data, error } =
    await supabaseClient.auth.signInWithPassword({
      email,
      password,
    });

  if (error) {
    if (error.message === "Invalid login credentials") {
      throw new Error("ID ou senha incorretos.");
    }

    throw error;
  }

  return data;
}

export async function signOut() {
  const { error } =
    await supabaseClient.auth.signOut();

  if (error) throw error;
}

export async function getEmployeeProfile(
  userId: string,
): Promise<EmployeeProfile> {
  const { data, error } = await supabaseClient
    .from("funcionarios")
    .select(
      "id,nome,email,login_id,cargo,ativo",
    )
    .eq("id", userId)
    .maybeSingle();

  if (error) throw error;

  if (!data) {
    throw new Error(
      "Seu usuário não possui perfil de funcionário.",
    );
  }

  if (!data.ativo) {
    throw new Error(
      "Este acesso está desativado.",
    );
  }

  return data as EmployeeProfile;
}
export async function verifyCurrentPassword(
  email: string,
  password: string,
) {
  const { error } =
    await supabaseClient.auth.signInWithPassword({
      email,
      password,
    });

  if (error) {
    throw new Error(
      "Senha incorreta.",
    );
  }

  return true;
}